import { render, staticRenderFns } from "./AnswerSheetResultsSummaryPage.vue?vue&type=template&id=36a7dc89&scoped=true&"
import script from "./AnswerSheetResultsSummaryPage.vue?vue&type=script&lang=js&"
export * from "./AnswerSheetResultsSummaryPage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSheetResultsSummaryPage.vue?vue&type=style&index=0&id=36a7dc89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7dc89",
  null
  
)

export default component.exports